import { create } from "zustand";

interface UseGlobalLoadingState {
  globalLoading: boolean;
  switchGlobalLoading: () => void;
}

const useGlobalLoading = create<UseGlobalLoadingState>((set) => ({
  globalLoading: false,
  switchGlobalLoading: () =>
    set((state) => ({ globalLoading: !state.globalLoading })),
}));

export default useGlobalLoading;
